export default function isFunction(f: any) {
  if (!f) {
    return false;
  }
  const type = Object.prototype.toString.call(f);
  return type === '[object Function]' || type === '[object AsyncFunction]';
}
